import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgQuestionMarkIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 17.2 28.9",
	style: { enableBackground: "new 0 0 17.2 28.9" },
	xmlSpace: "preserve",
	...props,
	children: [/* @__PURE__ */ _jsx("style", {
		type: "text/css",
		children: "\n	.question-mark-icon-st0{fill:currentColor;}\n	.question-mark-icon-st1{fill:none;stroke:currentColor;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n"
	}), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		className: "question-mark-icon-st0",
		d: "M8.6,28.9c1.3,0,2.3-1,2.3-2.3s-1-2.3-2.3-2.3s-2.3,1-2.3,2.3S7.3,28.9,8.6,28.9z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "question-mark-icon-st1",
		d: "M8.6,17.8v-2c1.4,0,2.8-0.4,4-1.2c1.2-0.8,2.1-1.9,2.6-3.2s0.7-2.7,0.4-4.1c-0.3-1.4-1-2.7-2-3.7 s-2.3-1.7-3.6-2S7.2,1.5,5.9,2S3.5,3.5,2.7,4.6c-0.8,1.2-1.2,2.6-1.2,4"
	})] }) }) })]
});
export default SvgQuestionMarkIcon;
